// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"_28opA","title":"Ncxft","text":"_21H8B","ok_btn":"_3lXVH","modalimg":"_25bM9"};